export const onlyNumbers = (str: string): string =>
  str.toString().replace(/[^0-9]/g, '');
